import PropTypes from "prop-types";

export const propTypes = {
  addvendorPayload: PropTypes.shape({}),
};

export const defaultProps = {
  addvendorPayload: undefined,
};
